module.exports = __webpack_public_path__ + "img/swisslife.805f3f86.png";